<template>
	<button @click="doClick" aria-label="Sign in">
		<slot></slot>
	</button>
</template>

<script>
export default {
	name: 'SignInBtn',

	props: {
		use_modal: {
			type: String
		},
    mode: {
      type: String,
      default: 'login' // login/join
    }
	},

	data() {
		return {

		}
	},

	mounted() {

	},

	methods: {
		doClick() {
			if (this.use_modal == "1") {
				this.emitter.emit("openModal", { name: 'SignIn', persistent: false, mode: this.mode });
			} else {
				window.location = this.url;
			}
		}
	},
}
</script>
